import * as toDesktopClientFs from '@todesktop/client-fs';
import { APP_DATA_FOLDER } from '../constants';
import { isDesktopApp } from '@todesktop/client-core/platform/todesktop';

export const getLocalFileSyncTenantId = async () => {
  if (!isDesktopApp() || !toDesktopClientFs || !toDesktopClientFs.stat) {
    return null;
  }

  const stats = await toDesktopClientFs.stat(APP_DATA_FOLDER, '/');
  return String(stats.dev);
};
